import type { SearchResponse, SearchProjectsResponse, MaterialFilters } from '@mrb91002/shared-types'

import { API_BASE } from '../config'

export async function searchPatterns(
  query: string,
  limit: number = 20,
  offset: number = 0,
  materialFilters?: MaterialFilters,
): Promise<SearchResponse> {
  const params = new URLSearchParams({
    q: query,
    limit: limit.toString(),
    offset: offset.toString(),
  })

  // Add material filters if provided
  if (materialFilters?.category) params.append('materialCategory', materialFilters.category)
  if (materialFilters?.brand) params.append('materialBrand', materialFilters.brand)
  if (materialFilters?.color) params.append('materialColor', materialFilters.color)
  if (materialFilters?.name) params.append('materialName', materialFilters.name)

  console.log('[searchPatterns] Query params:', params.toString())
  const response = await fetch(`${API_BASE}/search?${params}`)

  if (!response.ok) {
    throw new Error('Pattern search failed')
  }

  return response.json() as Promise<SearchResponse>
}

export async function searchProjects(query: string, limit: number = 20, offset: number = 0): Promise<SearchProjectsResponse> {
  const params = new URLSearchParams({
    q: query,
    limit: limit.toString(),
    offset: offset.toString(),
  })

  console.log('[searchProjects] Query params:', params.toString())
  const response = await fetch(`${API_BASE}/projects/search?${params}`)

  if (!response.ok) {
    throw new Error('Project search failed')
  }

  return response.json() as Promise<SearchProjectsResponse>
}

export async function searchByTag(tag: string, limit: number = 20, offset: number = 0): Promise<SearchResponse> {
  const params = new URLSearchParams({
    tag: tag,
    limit: limit.toString(),
    offset: offset.toString(),
  })

  const response = await fetch(`${API_BASE}/search?${params}`)

  if (!response.ok) {
    throw new Error('Tag search failed')
  }

  return response.json() as Promise<SearchResponse>
}

export async function searchByDifficulty(
  difficulty: string,
  limit: number = 20,
  offset: number = 0,
): Promise<SearchResponse> {
  const params = new URLSearchParams({
    difficulty: difficulty,
    limit: limit.toString(),
    offset: offset.toString(),
  })

  const response = await fetch(`${API_BASE}/search?${params}`)

  if (!response.ok) {
    throw new Error('Difficulty search failed')
  }

  return response.json() as Promise<SearchResponse>
}
